import localStorageService from '../../services/localStorageService';

import { FETCH_LOCATIONS, SET_LOCATION, SET_TRANSACTION_ACCOUNT, SET_DEFAULT_TRANSACTION_ACCOUNT } from '../actions/LocationActions';

const initialState = {
  selectedLocation: { id: 0, members: [] },
  locations: [],
  selectedTransactionAccount: { merchantId: 0 }
};

const locationReducer = function (state = initialState, action) {
  switch (action.type) {
    case FETCH_LOCATIONS: {
      let savedState = localStorageService.getItem('locationReducer');
      if (savedState === null) {
        savedState = state;
      }

      // this logic makes sure the selected location contains an updated list of members has changed
      // the localStorageService may have a old list of location members
      if (savedState.selectedLocation && savedState.selectedLocation.id !== 0) {
        let updatedSelectedLocation = action.payload.find(element => {
          return element.id === savedState.selectedLocation.id;
        });
        if (updatedSelectedLocation) {
          savedState.selectedLocation = updatedSelectedLocation;
        } else {
          localStorageService.setItem('locationReducer', null);
          return initialState;
        }
      }

      let newstate = {
        ...savedState,
        locations: action.payload,
        selectedLocation: savedState.selectedLocation,
        selectedTransactionAccount: savedState.selectedTransactionAccount
      };
      localStorageService.setItem('locationReducer', newstate);
      return newstate;
    }
    case SET_LOCATION: {
      let newstate = { ...state, selectedLocation: action.payload };
      localStorageService.setItem('locationReducer', newstate);
      return newstate;
    }
    case SET_TRANSACTION_ACCOUNT: {
      let newstate = { ...state, selectedTransactionAccount: action.payload };
      localStorageService.setItem('locationReducer', newstate);
      return newstate;
    }
    case SET_DEFAULT_TRANSACTION_ACCOUNT: {
      if (action.payload === null) return state;
      let savedState = localStorageService.getItem('locationReducer');

      if (savedState === null) {
        savedState = state;
      }

      let lastMerchantId = savedState.selectedLocation.members.find(element => {
        return element.merchantId === savedState.selectedTransactionAccount.merchantId;
      });

      if (lastMerchantId === undefined) {
        let defaultTrxAct = { merchantId: action.payload.id, merchantEmail: action.payload.email, merchantUsername: action.payload.userId };
        let newstate = { ...savedState, selectedTransactionAccount: defaultTrxAct };
        localStorageService.setItem('locationReducer', newstate);
        return newstate;
      }
      return savedState;
    }
    default:
      return state;
  }
};

export default locationReducer;
